import { render, staticRenderFns } from "./Stammdaten.vue?vue&type=template&id=51543a54&scoped=true"
import script from "./Stammdaten.vue?vue&type=script&lang=js"
export * from "./Stammdaten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51543a54",
  null
  
)

export default component.exports